import React, { useEffect } from 'react';
import './programassociales.css';
import { programassociales } from '../../json/programassociales';

const Programassociales = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className='container-full-width'>
      <div className='row'>
        <div className='col-12'>
          <h3 className='title'>Bienestar para Personas Artesanas</h3>
          <hr className='hr-gob' />
        </div>
      </div>
   
      <div className='row'>
        <div className='col-12 container-armon'>
          <div className='armo-collapse'>
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
             
              <div style={{ textAlign: 'left' }}>
                <h5 style={{ fontWeight: 'bold', color: 'var(--wine)' }}>Descripción del Programa</h5>
                <p>
                El programa de “Bienestar para Personas Artesanas" otorga apoyos económicos de $10,000.00 pesos a personas artesanas con el fin de fortalecer su actividad productiva mediante adquisición de equipamiento, herramientas, materias primas, insumos, maquinaria y mantenimiento de talleres.
                </p>
                <p>
                </p>
                <h6 className='description' style={{ marginTop: '20px' }}>
                </h6><br />
                <h5 style={{ fontWeight: 'bold', color: 'var(--wine)' }}>Objetivo del Programa</h5>
                <p>
                Contribuir al bienestar de las Personas Artesanas Hidalguenses, a través de la entrega de apoyos económicos, buscando con ello fortalecer sus proyectos productivos, mejorar su calidad de vida y condiciones en su trabajo artesanal, dando prioridad a la población que se encuentra en situación de marginación, pobreza extrema, rezago social o con población indígena.
                </p>
                <h5 style={{ fontWeight: 'bold', color: 'var(--wine)' }}>Población Objetivo</h5>
                <p>
                Personas Artesanas mayores de edad, que radiquen en el estado de Hidalgo, al momento de realizar la solicitud de incorporación al Programa, dando preferencia a las personas que habiten en las localidades de marginación, pobreza extrema, rezago social o con población indígena en el Estado de Hidalgo.
                </p>
                <h5 style={{ fontWeight: 'bold', color: 'var(--wine)' }}>Vigencia</h5>
                <p>
                Anual
                </p>
                <h5 style={{ fontWeight: 'bold', color: 'var(--wine)' }}>Áreas de atención</h5>
                <p> 
                <ul>
                <li><b>Secretaría de Bienestar en Inclusión Social</b></li>
                <dd>Blvd. Felipe Angeles, Km. 93.50, Centro Minero, Edificio 1B, Col, Venta Prieta, 42080 Pachuca de Soto, Hgo.</dd>
                <li><b>Subsecretaría de Participación Social y Fomento Artesanal.</b></li>
                <dd>Blvd. Felipe Angeles, Km. 93.50, Centro Minero, Edificio 1B, Col, Venta Prieta, 42080 Pachuca de Soto, Hgo.</dd>
                </ul></p>
                <h5 style={{ fontWeight: 'bold', color: 'var(--wine)' }}>Personas Responsables del Programa</h5>
                <p>
                Lic. Areli Maya Monsalvo: Subsecretaria de Participación Social y Fomento Artesanal
                </p>
                <p>
                <h5 style={{ fontWeight: 'bold', color: 'var(--wine)' }}>Teléfono de Contacto</h5>
                <p>
                771 107 3952 y 771 107 3958
                </p>
                 <h5 style={{ fontWeight: 'bold', color: 'var(--wine)' }}>Horario de Atención</h5>
                <p>
                Lunes a viernes de 09:00 a 17:00 hrs.
                </p>
                <h5 style={{ fontWeight: 'bold', color: 'var(--wine)' }}>Reglas de Operación</h5>
                <ul>
                <li>
                <a
                href='https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/pdfs/rops/2026/ROP_Bienestar_para_Personas_Artesanas_2026.pdf'
                target='_blank'
                rel="noopener noreferrer"
                className='link-custom'
                >ROP's 2026</a>
                </li>
                </ul>
                </p>
                
              </div>
            </div>
            
          </div>
        </div>
     
      </div>    
    </div>
  );
};

export default Programassociales;